import React from "react";
import JoinTattuneArtistWizard from "../../components/JoinTattuneArtistWizard.jsx";

export default function JoinWizardSection({ showJoin, setShowJoin }) {
  if (!showJoin) return null;
  return <JoinTattuneArtistWizard onClose={() => setShowJoin(false)} />;
}
